import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TextField, Autocomplete } from '@mui/material';
import { Translate } from 'react-localize-redux';
import { ButtonAccept, ButtonContinue } from '../../../components/general/mini_components';

interface ChangeCoverageModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (coverageId: number) => void;
    coverages: any[];
    currentCoverageId: number | null;
    loadingCoverages: boolean;
    isConfirming?: boolean;
}

const ChangeCoverageModal: React.FC<ChangeCoverageModalProps> = ({ open, onClose, onConfirm, coverages, currentCoverageId, loadingCoverages, isConfirming = false }) => {
    // Sort coverages alphabetically by name
    const sortedCoverages = [...(coverages || [])].sort((a, b) => a.name.localeCompare(b.name));
    const currentCoverageObj = sortedCoverages.find(c => c.id === currentCoverageId) || null;
    const [selectedCoverage, setSelectedCoverage] = useState<any>(currentCoverageObj);

    useEffect(() => {
        setSelectedCoverage(currentCoverageObj);
        // eslint-disable-next-line
    }, [currentCoverageId, open, coverages]);

    const handleConfirm = () => {
        if (selectedCoverage && selectedCoverage.id !== currentCoverageId) {
            onConfirm(selectedCoverage.id);
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle><Translate id="hospital.billing.bill.change_coverage.confirm_title" /></DialogTitle>
            <DialogContent>
                <Typography gutterBottom>
                    <Translate id="hospital.billing.bill.change_coverage.confirm_message" />
                </Typography>
                <Autocomplete
                    fullWidth
                    options={sortedCoverages}
                    getOptionLabel={(option) => option.name}
                    value={selectedCoverage}
                    onChange={(_, value) => setSelectedCoverage(value)}
                    loading={loadingCoverages}
                    renderInput={(params) => (
                        <TextField {...params} label={<Translate id="investigation.create.personal_data.fields.coverage" />} variant="outlined" />
                    )}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    disabled={loadingCoverages || isConfirming}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" disabled={isConfirming}>
                    <Translate id="general.cancel" />
                </Button>
                <ButtonContinue onClick={handleConfirm} disabled={!selectedCoverage || selectedCoverage.id === currentCoverageId || isConfirming}>
                    <Translate id="general.confirm" />
                </ButtonContinue>
            </DialogActions>
        </Dialog>
    );
};

export default ChangeCoverageModal;

